var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoResultsMagnifier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    id: "_x3C_Layer_x3E_",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search_x2C__magnifier_x2C__magnifying_x2C__emoji_x2C__happy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1949_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2132_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,14.521h2c0,0.55-0.45,1-1,1S12,15.07,12,14.521z",
    fill: "#263238",
    id: "XMLID_2137_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5,13c0.27,0,0.5,0.23,0.5,0.5S17.77,14,17.5,14S17,13.77,17,13.5S17.23,13,17.5,13z     ",
    fill: "#263238",
    id: "XMLID_2134_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5,13C8.77,13,9,13.23,9,13.5S8.77,14,8.5,14S8,13.77,8,13.5S8.23,13,8.5,13z",
    fill: "#263238",
    id: "XMLID_2133_"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1838_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4088_"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "XMLID_4094_",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 23.43,
    x2: 21.214,
    y1: 23.401,
    y2: 21.186
  }), /*#__PURE__*/React.createElement("path", {
    d: "     M29.914,27.086l-3.5-3.5c-0.756-0.756-2.072-0.756-2.828,0C23.208,23.964,23,24.466,23,25s0.208,1.036,0.586,1.414l3.5,3.5     c0.378,0.378,0.88,0.586,1.414,0.586s1.036-0.208,1.414-0.586S30.5,29.034,30.5,28.5S30.292,27.464,29.914,27.086z",
    fill: "none",
    id: "XMLID_4093_",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    fill: "none",
    id: "XMLID_4092_",
    r: 11.5,
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "     M12,14.521h2c0,0.55-0.45,1-1,1S12,15.07,12,14.521z",
    fill: "none",
    id: "XMLID_4091_",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "     M17.5,13c0.27,0,0.5,0.23,0.5,0.5S17.77,14,17.5,14S17,13.77,17,13.5S17.23,13,17.5,13z",
    fill: "none",
    id: "XMLID_4090_",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "     M8.5,13C8.77,13,9,13.23,9,13.5S8.77,14,8.5,14S8,13.77,8,13.5S8.23,13,8.5,13z",
    fill: "none",
    id: "XMLID_4089_",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3004_"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "XMLID_4087_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 23.43,
    x2: 21.214,
    y1: 23.401,
    y2: 21.186
  }), /*#__PURE__*/React.createElement("path", {
    d: "     M29.914,27.086l-3.5-3.5c-0.756-0.756-2.072-0.756-2.828,0C23.208,23.964,23,24.466,23,25s0.208,1.036,0.586,1.414l3.5,3.5     c0.378,0.378,0.88,0.586,1.414,0.586s1.036-0.208,1.414-0.586S30.5,29.034,30.5,28.5S30.292,27.464,29.914,27.086z",
    fill: "none",
    id: "XMLID_3009_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    fill: "none",
    id: "XMLID_3008_",
    r: 11.5,
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "     M12,14.521h2c0,0.55-0.45,1-1,1S12,15.07,12,14.521z",
    fill: "none",
    id: "XMLID_3007_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "     M17.5,13c0.27,0,0.5,0.23,0.5,0.5S17.77,14,17.5,14S17,13.77,17,13.5S17.23,13,17.5,13z",
    fill: "none",
    id: "XMLID_3006_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "     M8.5,13C8.77,13,9,13.23,9,13.5S8.77,14,8.5,14S8,13.77,8,13.5S8.23,13,8.5,13z",
    fill: "none",
    id: "XMLID_3005_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResultsMagnifier);
export default __webpack_public_path__ + "static/media/NoResultsMagnifier.7c89d180b1844a720519ffff6741ccf4.svg";
export { ForwardRef as ReactComponent };